export default "mutation extendValidPeriod($extendInfo: ExtendValidPeriodRequest) {\n  extendValidPeriod(extendInfo: $extendInfo) \n}";